import { implementCustomExpressions } from '../__generated/implementation.js';
import { ApplianceWithPowderCoating, PulsePowderCoatableRoomItem, SwatchPowderCoatableRoomItem } from '../__generated/model/index.js';
import { PricingType, getCurrentUserPrice } from '../data/pricing.js';
import { isDealer } from '../util/auth.js';
export const roomItemExpressions = implementCustomExpressions({
    RoomItem: {
        $price: (s, _state, ctx)=>{
            if (isDealer(ctx.sessionData)) {
                return s.$dealerPrice;
            }
            return s.$retailPrice;
        }
    },
    RoomItemWithDefaultPrice: {
        $dealerPrice: (s, _state, ctx)=>{
            const price = getCurrentUserPrice(ctx.publishedData.prices?.[s.$priceSku], {
                userType: PricingType.Dealer,
                powderCoatType: s.$room.powderCoatType,
                includeSwatchUpcharge: SwatchPowderCoatableRoomItem.is(s),
                includePulseUpcharge: PulsePowderCoatableRoomItem.is(s)
            });
            return price;
        },
        $retailPrice: (s, _state, ctx)=>{
            const price = getCurrentUserPrice(ctx.publishedData.prices?.[s.$priceSku], {
                userType: PricingType.Retail,
                powderCoatType: s.$room.powderCoatType,
                includeSwatchUpcharge: SwatchPowderCoatableRoomItem.is(s),
                includePulseUpcharge: PulsePowderCoatableRoomItem.is(s)
            });
            return price;
        }
    },
    RoomItemWithDefaultSummary: {
        $summary: (s, _state, ctx)=>{
            const publishedProductData = ctx.publishedData.prices?.[s.$priceSku];
            if (!publishedProductData) {
                throw new Error(`No published product data found for sku: ${s.$priceSku}`);
            }
            return [
                {
                    id: s.id,
                    name: s.$name,
                    sku: s.$sku,
                    dealerPrice: s.$dealerPrice,
                    retailPrice: s.$retailPrice,
                    currentUserPrice: isDealer(ctx.sessionData) ? s.$dealerPrice : s.$retailPrice,
                    packageDepth: publishedProductData.packageDepth,
                    packageHeight: publishedProductData.packageHeight,
                    packageWidth: publishedProductData.packageWidth,
                    packageWeight: publishedProductData.packageWeight,
                    ...ApplianceWithPowderCoating.is(s) && s.powderCoating ? {
                        color: s.$room.cabinetColor
                    } : {}
                }
            ];
        }
    }
});

//# sourceMappingURL=room-item.js.map